/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import * as CpdsVideoPlay from './styles/cpds-video-play-button-style';
import { CpdsVideoPlayButtonProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';
import { Cpds } from '@Cpds.Ui';
import { mediaQueryVals } from 'components/common/cpds/token/shared/common';
import { css } from 'styled-components';

const CpdsVideoPlayButton: React.FC<CpdsVideoPlayButtonProps> = (props) => {
  const { domRef, exClasses, styleOverrides, themeTypography, children } = props;
  const className = themeStyleClass('cpds-video-play-button', themeTypography, exClasses);

  const {
    togglePlay,
    isPlaying,
    togglePlaysound,
    togglePlayWithSound,
    hideSoundControlsForVideo,
    isMuted,
    progress,
    currentTime,
    themeTokens,
    withSounds,
    playBtnColor,
    isDisabled,
    playerState,
  } = props;

  const [buttonVisible, setButtonVisible] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const togglePlayPause = () => {
    if (withSounds) {
      togglePlayWithSound();
    } else {
      togglePlay();
    }

    setButtonVisible(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      !isPlaying && setButtonVisible(false);
    }, 3000); // Hide button after 3 seconds
  };

  return (
    <CpdsVideoPlay.Overlay colorVariant={playBtnColor} disabled={isDisabled} playerState={playerState}>
      <CpdsVideoPlay.PlayButton
        className={className}
        ref={domRef}
        styleOverrides={styleOverrides}
        onClick={togglePlayPause}
        visible={playerState === 0 || buttonVisible}
        colorVariant={playBtnColor}
        disabled={isDisabled}
      >
        <Cpds.Icon
          id="CustomVideoControl"
          name={isPlaying ? 'pause-filled' : 'play-filled'}
          customSize={{ width: '29.33', height: '37.33' }}
          styleOverrides={css`
            padding-left: ${!isPlaying ? '10px' : '0'};
            @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
              width: 14px;
              height: 14px;
              padding-left: ${!isPlaying ? '4px' : '0'};
            }
          `}
        />
      </CpdsVideoPlay.PlayButton>
    </CpdsVideoPlay.Overlay>
  );
};

const CpdsVideoPlayButtonWithSound: React.FC<CpdsVideoPlayButtonProps> = (props) => {
  // Additional props you want to pass
  const additionalProps = {
    ...props,
    withSounds: true,
  };

  return <CpdsVideoPlayButton {...additionalProps} />;
};

export default { MutedControls: CpdsVideoPlayButton, WithSoundsControls: CpdsVideoPlayButtonWithSound };
